import { Copy } from 'smg/clipboard';
import * as strings from 'smg/strings';
import { Success } from 'smg/toast';
import i18n from '../i18n';

// How long a copy button shows its confirmation before going back to its label.
const copiedMs = 2000;

// A copy button that carries a label of its own confirms in place, where the
// person is already looking; one without a label has nowhere to say it, so it
// toasts (the marketing Contact page's cards).
document.body.addEventListener('click', e => {
    const $target = e.target instanceof Element ? e.target.closest('.copy-email') : null;
    if (!($target instanceof HTMLElement)) {
        return;
    }

    e.preventDefault();

    const email = $target.dataset['email'] ||
        ($target instanceof HTMLAnchorElement ? strings.TrimPrefix($target.href, 'mailto:') : '');
    if (!email) {
        return;
    }
    Copy(email);

    const $label = $target.querySelector('.copy-email-label');
    const copied = $target.dataset['copied'];
    if (!($label instanceof HTMLElement) || !copied) {
        Success(i18n('contactCardsCopyEmailSuccess'));
        return;
    }

    if ($target.dataset['copying']) {
        return;
    }
    const label = $label.textContent ?? '';
    $target.dataset['copying'] = '1';
    $label.textContent = copied;
    window.setTimeout(() => {
        $label.textContent = label;
        delete $target.dataset['copying'];
    }, copiedMs);
});
